export const EVENT_FORM_SECTION_IDS = [
  'essentials',
  'registration',
  'questions',
  'content',
  'day_of',
  'visibility',
] as const;

export type EventFormSectionId = (typeof EVENT_FORM_SECTION_IDS)[number];

export type EventFormValidationTarget = Readonly<{
  field: string;
  section: EventFormSectionId;
}>;

const EVENT_FORM_VALIDATION_TARGETS: Readonly<Record<string, EventFormValidationTarget>> = {
  capacity: { field: 'capacity', section: 'registration' },
  description: { field: 'description', section: 'essentials' },
  eventLinks: { field: 'eventLinks', section: 'content' },
  media: { field: 'media', section: 'content' },
  paymentMethods: { field: 'paymentMethods', section: 'registration' },
  place: { field: 'place', section: 'essentials' },
  registrationForm: { field: 'registrationForm', section: 'questions' },
  registrationPrice: { field: 'registrationPrice', section: 'registration' },
  title: { field: 'title', section: 'essentials' },
};

export function eventFormValidationTarget(field: string): EventFormValidationTarget {
  return EVENT_FORM_VALIDATION_TARGETS[field] ?? { field, section: 'essentials' };
}

export type EventRouteFlowState = 'closed' | 'library' | 'planner';

export type EventRouteFlowAction =
  | Readonly<{ type: 'close' }>
  | Readonly<{ type: 'open-library' }>
  | Readonly<{ type: 'start-planning' }>;

export function eventRouteFlowReducer(
  state: EventRouteFlowState,
  action: EventRouteFlowAction
): EventRouteFlowState {
  switch (action.type) {
    case 'close':
      return 'closed';
    case 'open-library':
      return 'library';
    case 'start-planning':
      return state === 'library' ? 'planner' : state;
  }
}

export type RegistrationPresentationStep = 'questions' | 'confirmation' | 'payment' | 'success';

export function registrationPresentationSteps({
  confirmed,
  formRequired,
  paymentDue,
}: Readonly<{
  confirmed: boolean;
  formRequired: boolean;
  paymentDue: boolean;
}>): RegistrationPresentationStep[] {
  if (confirmed) {
    return ['success'];
  }

  const steps: RegistrationPresentationStep[] = [];
  if (formRequired) {
    steps.push('questions');
  }
  steps.push(paymentDue ? 'payment' : 'confirmation');
  return steps;
}

export function registrationPresentationStepLabel(step: RegistrationPresentationStep): string {
  switch (step) {
    case 'questions':
      return 'Questions';
    case 'confirmation':
      return 'Confirm';
    case 'payment':
      return 'Payment';
    case 'success':
      return 'Complete';
  }
}
